// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 265 ? "component---src-templates-page-tsx" : chunkId) + "-" + {"68":"8a1ac7f4fa2f079d8a40","265":"588d220c74e3793531c0"}[chunkId] + ".js";
};